import React, { Fragment } from "react";

import { IconButton } from "@mui/material";

import { useGetIsValidSessionid } from "../../hooks/useGetIsValidSessionid";
import { useChatStore } from "../../reducer/Context";
import AddPlus from "@src/assets/svg/components/AddPlus";
import ExpandCollapseButton from "@src/assets/svg/components/ExpandCollapseButton";
import MoreDots from "@src/assets/svg/components/MoreDots";
import Conditional from "@src/sharedComponents/Conditional/Conditional";
import Menu from "@src/sharedComponents/Menu/Menu";

import styles from "../../style/ChatBotWindow.module.css";

interface ChatHeaderRightProps {
  isExpanded: boolean;
  onToggleExpand: () => void;
  onAddChat: () => void;
  onAction: (
    action: "delete"
  ) => (event: React.MouseEvent<HTMLElement>) => void;
}

const ChatHeaderRight: React.FC<ChatHeaderRightProps> = ({
  isExpanded,
  onToggleExpand,
  onAddChat,
  onAction,
}) => {
  const { sessionId } = useChatStore();

  const isValidSessionId = useGetIsValidSessionid(sessionId);

  return (
    <Fragment>
      <Conditional condition={isValidSessionId}>
        <Menu
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          options={[
            {
              label: "Delete Chat",
              onClick: onAction("delete"),
              isCloseOnClick: true,
            },
          ]}
        >
          {({ handleOpenMenu }) => (
            <IconButton onClick={handleOpenMenu}>
              <MoreDots />
            </IconButton>
          )}
        </Menu>
      </Conditional>
      <Conditional condition={!sessionId}>
        <IconButton onClick={onAddChat}>
          <AddPlus />
        </IconButton>
      </Conditional>
      <ExpandCollapseButton
        isExpanded={isExpanded}
        onClick={onToggleExpand}
        className={styles.controlButton}
      />
    </Fragment>
  );
};

export default ChatHeaderRight;
